import { clearLineLinkSnapshot } from "./lineLink";
import {
  clearLineOAuthAttempt,
  clearLineOAuthContextSnapshot,
  clearLineOAuthPending,
  clearLineOAuthPopupSnapshot,
  clearLineOAuthTokenSnapshot,
} from "./lineOAuthPopup";
import { storage } from "./storage";

const LINE_OAUTH_DEBUG_STORAGE_KEYS = [
  "wizmate.line-oauth-diagnostic",
  "wizmate.lineOAuthDebug",
] as const;

function clearLegacyLineOAuthDebugState() {
  if (typeof window === "undefined") return;

  for (const key of LINE_OAUTH_DEBUG_STORAGE_KEYS) {
    try {
      window.localStorage.removeItem(key);
      window.sessionStorage.removeItem(key);
    } catch {
      // noop
    }
  }
}

export function clearFrontendAuthState() {
  storage.clearAuth();
  clearLineLinkSnapshot();
  clearLineOAuthPopupSnapshot();
  clearLineOAuthContextSnapshot();
  clearLineOAuthPending();
  clearLineOAuthAttempt();
  clearLineOAuthTokenSnapshot();
  clearLegacyLineOAuthDebugState();
}

export function logoutToSplash() {
  clearFrontendAuthState();
  window.location.replace("/splash");
}
